import { render, staticRenderFns } from "./TemplateLoginProfessional.vue?vue&type=template&id=70d1ea15&scoped=true"
import script from "./TemplateLoginProfessional.vue?vue&type=script&lang=js"
export * from "./TemplateLoginProfessional.vue?vue&type=script&lang=js"
import style0 from "./TemplateLoginProfessional.vue?vue&type=style&index=0&id=70d1ea15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1ea15",
  null
  
)

export default component.exports